import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f510270")

_pushScopeId("data-v-8f510270")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20220917/4B825D7F-4D0B-26BB-891F-D065E5624856.gif",
  class: "dataimg",
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_swiper, {
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: { "clickable": true }
    }, {
      default: _withId(() => [
        _createVNode(_component_swiper_slide, null, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})